import React from "react"

class CampEdit extends React.Component {
  render() {
    return <div>CAMP EDIT</div>
  }
}

export default CampEdit



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampEdit/index.js